jQuery(function($){

  $.fn.extend({
    // トップメインスライド
    topVisual:function(options){
      var defaults={
        prefix:'top-visual',
        speed:0.4,
        interval:6000,
        afterLoad:new Function
      };
      var op=$.extend(defaults,options);
      var $t=$(this);
      var $frame=$t.find('.'+op.prefix+'-frame');
      var $move=$t.find('.'+op.prefix+'-move');
      var $item=$move.find('.'+op.prefix+'-item');
      var $bullets=$('<div class="'+op.prefix+'-bullets" />');
      var len=$item.length;
      var len2=len;
      var index=len;
      var w=function(){
        var ww=$(window).width();
        if(ww>1225){
          var v=1185;
        }else{
          var v=$frame.innerWidth();
        };
        return Math.round(v);
      };
      var space=function(){
        var v=(is_sp())?0:3;
        return Math.round(v);
      };
      var marginLeft=function(){
        var ww=$(window).width();
        if(ww>1225){
          var v=(ww-1185)/2;
        }else{
          var v=0;
        };
        v=v-space();
        return Math.round(v);
      };
      var move_w=function(){ var v=w()+space(); return v; };
      var bool=true;
      var first=true;
      var touch={
        X:0,
        now:0,
        move:0,
        pos:0,
        bool:false,
        left:function(){ v=new WebKitCSSMatrix($move.css('transform')); return Math.floor(v.e); }
      };
      var initialize=function(){
        clearTimeout(slideInterval);
        $move.width(move_w()*len2).css({ transform:'translate3d(-'+(move_w()*index)+'px,0,0)',marginLeft:marginLeft()+'px' });
        $item.css({ marginLeft:space()+'px' }).width(w());
        slideAuto();
      };
      var bulletsControl=function(){
        var bullets_index=index-len;
        $bullets.find('a.active').removeClass('active');
        $bullets.find('a').eq(bullets_index).addClass('active');
      };
      var slideEvent=function(){
        $move.css({ transitionTimingFunction:'ease-out',transition:op.speed+'s',transform:'translate3d(-'+move_w()*index+'px,0,0)' });
        setTimeout(function(){
          if(index==len-1){
            index=len*2-1;
          }else if(index==len*2){
            index=len;
          };
          $move.css({ transitionTimingFunction:'none',transition:'none',transform:'translate3d(-'+(move_w()*index)+'px,0,0)' });
          $item.removeClass('active');
          $item.eq(index).addClass('active');
          bulletsControl();
          bool=true;
          clearTimeout(slideInterval);
          slideAuto();
        },op.speed*1000);
      };
      var slideAuto;
      var slideInterval;
      slideAuto=function(){
        if(op.interval){
          slideInterval=setTimeout(function(){
            if(bool){
              bool=false;
              index=index+1;
              clearTimeout(slideInterval);
              slideEvent();
            };
          },op.interval);
        };
      };
      var resetSlide=function(){
        clearTimeout(slideInterval);
        $move.css({ transitionTimingFunction:'none',transition:'none' });
        if(len>1){
          setTimeout(function(){ slideAuto(); },op.interval);
        };
        initialize();
      };
      var start=function(){
        initialize();
        if(first){
          first=false;
          if(len>1){
            for(var i=0;i<len;i++){
              $move.append($item.eq(i).clone(true));
              $move.prepend($item.eq((len-1)-i).clone(true));
              $bullets.append('<a href="#">'+(i+1)+'</a>');
            };
            $item=$move.find('.'+op.prefix+'-item');
            len2=$item.length;
            $item.eq(index).addClass('active');
            $t.append($bullets);
            bulletsControl();
            setTimeout(function(){
              $t.animate({ opacity:1 },400);
              resetSlide();
            },200);
            $bullets.find('a').each(function(){
              $(this).off('click');
              $(this).on('click',function(){
                if(bool){
                  bool=false;
                  index=$bullets.find('a').index($(this));
                  index=index+len;
                  clearTimeout(slideInterval);
                  slideEvent();
                };
                return false;
              });
            });
            $move.on({
              'touchstart':function(event){
                touch.bool=true;
                $(this).css({ transitionTimingFunction:'none',transition:'none' });
                touch.X=event.touches[0].pageX;
                touch.Y=event.touches[0].pageY;
                touch.move=touch.X-touch.left();
                touch.now=Math.floor(new WebKitCSSMatrix($move.css('transform')).e);
              },
              'touchmove':function(event){
                if(Math.abs(touch.X-event.touches[0].pageX)>5&&touch.bool){
                  if(event.cancelable) event.preventDefault();
                  touch.pos=Math.floor(event.touches[0].pageX);
                  $(this).css({ transform:'translate3d('+(touch.pos-touch.move)+'px,0,0)' });
                }else{
                  touch.bool=false;
                };
              },
              'touchend':function(event){
                if(bool&&touch.bool){
                  bool=false;
                  if((touch.pos-touch.move)>=0){
                    index=0;
                  }else if(touch.now>touch.left()){
                    index=index+1;
                  }else if(touch.now<touch.left()){
                    index=index-1;
                  };
                  clearTimeout(slideInterval);
                  slideEvent();
                };
              }
            });
          }else{
            index=0;
            $item.eq(index).addClass('active');
            setTimeout(function(){
              $t.animate({ opacity:1 },400);
              resetSlide();
            },200);
          };
          for(var i=0;i<len;i++){
            $item.eq(i).addClass('origin');
          };
          if(op.afterLoad) op.afterLoad($t);
        };
      };

      if($item.eq(len-1).find('img').length){
        $item.eq(len-1).find('img').one('load',function(){
          start();
        }).each(function(){
          if(this.complete) start();
        });
      }else{
        $(document).ready(function(){
          start();
        });
      };

      $(window).on({
        'resize':function(){
          $move.css({ transitionTimingFunction:'none',transition:'none' });
          initialize();
        }
      });
    }
  });

  if($('.top-visual').length) $('.top-visual').topVisual();

});